"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AreYouSureModalState = /** @class */ (function () {
    function AreYouSureModalState() {
    }
    return AreYouSureModalState;
}());
exports.default = AreYouSureModalState;
//# sourceMappingURL=AreYouSureModalState.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/LoginWidget/SavedIdView/RemoveSavedID/AreYouSureModal/AreYouSureModalState.js
// module id = 1511
// module chunks = 8